import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import UpscGsPaperTag from './UpscGsPaperTag';
import { UpscCurrentAffairsTopicArticle } from './upscCurrentAffairsTopicTypes';

const ArticleHeader = styled.header`
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-divider);
`;

const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 10px;
`;

const PageTitle = styled.h1`
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.25;
  color: var(--color-text-primary);

  ${mediaQuery.uptoMobile} {
    font-size: 22px;
  }
`;

const PageSubtitle = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.4;
  color: var(--color-text-secondary);
`;

export interface UpscCurrentAffairsDetailedPageHeaderProps {
  article: UpscCurrentAffairsTopicArticle;
}

const UpscCurrentAffairsDetailedPageHeader = ({
  article
}: UpscCurrentAffairsDetailedPageHeaderProps) => (
  <ArticleHeader>
    <TagRow>
      {article.gsPaper.map((paper, paperIndex) => (
        <UpscGsPaperTag
          key={`${article.id}-${paper}`}
          label={paper}
          index={paperIndex}
        />
      ))}
      {article.reference ? (
        <UpscGsPaperTag
          label={article.reference}
          index={article.gsPaper.length}
        />
      ) : null}
    </TagRow>
    <PageTitle>{article.mainHeading}</PageTitle>
    <PageSubtitle>{article.subHeading}</PageSubtitle>
  </ArticleHeader>
);

export default UpscCurrentAffairsDetailedPageHeader;
